import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Form, Button } from 'react-bootstrap';
import * as Yup from 'yup';
import RequiredIndicator from '../RequiredIndicator/RequiredIndicator';
const AddressForm = ({edit, initialValues, onSubmit }) => {
    
    const formik = useFormik({
        initialValues:initialValues,
        validationSchema: Yup.object({
            name: Yup.string().required("Обов'язкове поле"),
            address: Yup.string().required("Обов'язкове поле"),
            active: Yup.boolean().default(false),
        }),
        onSubmit: (values, { resetForm }) => {
            onSubmit(values);
            resetForm();
        },
    });

    useEffect(() => {
        formik.setValues(initialValues);
    }, [initialValues]);

    return (
        <div>
            <Form onSubmit={formik.handleSubmit}>
                <Form.Group controlId="name">
                    <Form.Label>Назва <RequiredIndicator /></Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter name"
                        name="name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                        isInvalid={formik.touched.name && formik.errors.name}
                    />
                    {formik.touched.name && formik.errors.name ? (
                        <div className="text-danger">{formik.errors.name}</div>
                    ) : null}
                </Form.Group>
                <Form.Group controlId="address">
                    <Form.Label>Адреса <RequiredIndicator /></Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter address"
                        name="address"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.address}
                        isInvalid={formik.touched.address && formik.errors.address}
                    />
                    {formik.touched.address && formik.errors.address ? (
                        <div className="text-danger">{formik.errors.address}</div>
                    ) : null}
                </Form.Group>
                <Form.Group controlId="active">
                    <Form.Check
                        type="switch"
                        id="active-checkbox"
                        label="Активувати"
                        name="active"
                        onBlur={formik.handleBlur}
                        checked={formik.values.active}
                        onChange={(e) => formik.setFieldValue('active', e.target.checked)}
                    />
                    {formik.touched.active && formik.errors.active ? (
                        <div className="text-danger">{formik.errors.active}</div>
                    ) : null}
                </Form.Group>

                <Button variant="dark" type="submit">
                    {edit ? "Редагування адреси" : "Створити адресу"} 
                </Button>
            </Form>
        </div>
    );
};

export default AddressForm;
